import React from "react";
import {connect, ConnectedProps} from "react-redux";
import {Login, AuthGState} from "@leap4/frontend";
import {RootState} from "../../../interfaces/root-state.interface";
import {
    BACKEND_SERVICE_NAME,
    setCookieUrl,
    requiredAuthRoles, meMultiUrl
} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}

const LoginContainer = ({auth}: IProps) => {

    const user = auth.user;
    const loginUrl = process.env.REACT_APP_AUTH_SERVER_BASE_URL
        ? `${process.env.REACT_APP_AUTH_SERVER_BASE_URL}/users/login`
        : undefined;
    return <Login {...{user, redirectUrlForAuthenticated: urlService.reporting(), setCookieUrl}}
                  serviceName={BACKEND_SERVICE_NAME}
                  meUrl={meMultiUrl}
                  requiredRoles={requiredAuthRoles}
                  dashboardName={"Conversions"}
                  loginUrl={loginUrl}
    />;
}

export default connector(LoginContainer)
